"use client";

import { QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider } from "./providers/theme-provider";
import { queryClient } from "./lib/query-client";
import { Toaster } from "./components/ui/sonner";
import {
  imagineConfigStore,
  useImagineTheme,
} from "./stores/imagine-config.store";
import { useAnalyticsIdentity } from "./hooks/use-analytics";
import { PostHogProvider } from "posthog-js/react";
import { posthogClient } from "./lib/analytics";
import { BillingProvider } from "./providers/billing-provider";

export function ClientProviders({ children }: { children: React.ReactNode }) {
  const imagineTheme = useImagineTheme();
  const config = imagineConfigStore.getState().config;

  if (!config) {
    throw new Error("ImagineConfig is not initialized");
  }

  return (
    <ThemeProvider
      attribute="class"
      forcedTheme={imagineTheme}
      disableTransitionOnChange
    >
      <PostHogProvider client={posthogClient}>
        <QueryClientProvider client={queryClient}>
          <AnalyticsBootstrap />
          <BillingProvider>{children}</BillingProvider>
        </QueryClientProvider>
      </PostHogProvider>
      <Toaster position="top-right" />
    </ThemeProvider>
  );
}

function AnalyticsBootstrap() {
  useAnalyticsIdentity();
  return null;
}
